<template>
  <v-container fluid ma-0 pa-0 fill-height>
    <!-- School Condition and standard goes here -->
    <v-row justify="center" class="pa-1 ma-0">      
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="sch_info.lang"
          :items="schLanguageType"
          item-text="text"
          item-value="value"
          outline
          label="ភាសាប្រើក្នុងការរៀននិងបង្រៀន"
          hide-details
          @keypress.native="onSelect3($event)"
        >
        </v-select>
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          v-model="sch_info.othe"
          label="ផ្សេងៗ"
        />
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="sch_info.hvno"
          :items="proKas"
          item-text="text"
          item-value="value"
          outline
          label="ប្រកាស"
          hide-details
          @keypress.native="onSelect4($event)"
        >
        </v-select>
      </v-col>      
      <HelpIcon :help="pd[0]"/>      
      <v-col class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          hide-details
          v-model="sch_info.deno"
          type="number"
          label="ប្រកាសលេខ"
        />
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          placeholder="dd-mm-yyyy"
          :rules="[rules.declareDate]"
          v-model="sch_info.deda"
          label="ចុះថ្ងៃ"
        />
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="sch_info.depv"
          :items="proKasBy"
          item-text="text"
          item-value="value"
          outline
          label="ចេញប្រកាសដោយ"
          hide-details
          @keypress.native="onSelect5($event)"
        >
        </v-select>
      </v-col>
    </v-row>
    <!-- Layout of school principle, and school infomation -->
    <v-divider class="pa-0 my-1"></v-divider>
    <v-row class="pa-0 ma-1">
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <principle :data="sch_prin" :ldata="sch_info" :title="title[1]" :htext1="pd[1]" :htext2="pd[3]"/>
      </v-col>
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <schoolinfo :data="sch_info" :infor="sec_info" :title="title[2]" :htext="pd[2]" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import principle from "@/components/privateascf/sharedCom/schoolPrinciple.vue";
import schoolInfo from "@/components/privateascf/sec/secSchoolInfo.vue";
import { schLanguageType, proKas, proKasBy } from "@/utils/priascf/commonVariables.js";
import { pd } from "@/utils/zdesc/privDesc.js"

export default {
  props: ["title", "sch_prin", "sch_info", "sec_info"],
  components: {
    schoolinfo: schoolInfo,
    principle: principle,
  },
  data() {
    return {
      schLanguageType: schLanguageType,
      proKas: proKas,
      proKasBy: proKasBy,
      rules: {
        // :rules="[rules.required, rules.email]"
        required: (value) => !!value || "Required.",
        declareDate: (value) => {
          const pattern = /^(((((0[1-9])|(1\d)|(2[0-8]))-((0[1-9])|(1[0-2])))|((31-((0[13578])|(1[02])))|((29|30)-((0[1,3-9])|(1[0-2])))))-((20[0-9][0-9]))|(29-02-20(([02468][048])|([13579][26]))))$/;
          return pattern.test(value) || "សូមវាយទំរង់ dd-mm-yyyy";
        },
      },
      pd: pd
    };
  },
  methods: {
    onSelect3: function (event) {
      //9 options
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 57) {
        this.sch_info.lang = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event) {      
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.sch_info.hvno = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect5: function (event) {
      //9 options
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 54) {
        this.sch_info.depv = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>